import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getListMaps } from "../services/mapServices";
import { useEffect, useState } from "react";
import { useCanvasStore } from "../store/canvasStore";
import transformToOption from "../utils/transformToOptionSelect";

export function useMapsList() {
  const [storeId, setStoreId] = useState(null);

  const { setAllMaps } = useCanvasStore();
  const maps = useQuery({
    queryKey: ["maps", storeId],
    queryFn: () => getListMaps(storeId),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: !!storeId,
  });

  const loadMaps = (storeId) => {
    if (storeId) setStoreId(storeId);
  };

  useEffect(() => {
    if (maps.data) {
      setAllMaps(maps.data);
    }
  }, [maps.data, setAllMaps]);

  return {
    maps: maps.data || null,
    mapOptions: storeId && maps.data ? transformToOption(maps.data) : [],
    loadMaps,
  };
}
